import React from 'react';
import { useNavigate } from 'react-router-dom';

const PrivacyPolicy = () => {
  const navigate = useNavigate();

  return (
    <div className="page-content">
      <div className="policy-page">
        <button 
          className="btn outline" 
          onClick={() => navigate(-1)}
          style={{ marginBottom: '2rem' }}
        >
          ← Back
        </button>
        
        <div className="policy-header">
          <h1 className="policy-title">🔐 Privacy Policy</h1>
          <p className="policy-date">Effective Date: January 14, 2025</p>
        </div>
        
        <div className="policy-content">
          <div className="policy-section">
            <p>At NeoTeeForge, your privacy is important to us. This Privacy Policy explains how we collect, use, and protect your personal information when you visit or make a purchase from our website.</p>
          </div>

          <div className="policy-section">
            <h3>Information We Collect</h3>
            <p>We may collect the following information:</p>
            <ul className="policy-list">
              <li>Name, email address, phone number</li>
              <li>Billing and shipping address</li>
              <li>Order and payment details (payments are processed securely via third-party gateways)</li>
              <li>Website usage data (cookies, IP address, browser type)</li>
              <li>Reading preferences and wishlist items</li>
              <li>Account creation information</li>
            </ul>
          </div>

          <div className="policy-section">
            <h3>How We Use Your Information</h3>
            <p>We use your information to:</p>
            <ul className="policy-list">
              <li>Process and deliver orders</li>
              <li>Communicate order updates and customer support</li>
              <li>Improve our products and website experience</li>
              <li>Send important service-related emails</li>
              <li>Personalize your reading recommendations</li>
              <li>Process refunds and returns</li>
              <li>Comply with legal obligations</li>
            </ul>
          </div>

          <div className="policy-section">
            <h3>Data Protection</h3>
            <p>We implement reasonable security measures to protect your personal information. We use industry-standard encryption for all sensitive data and regularly update our security protocols.</p>
            <p><strong>We do not sell or rent your data to third parties.</strong></p>
          </div>

          <div className="policy-section">
            <h3>Third-Party Services</h3>
            <p>Payments and digital downloads may be handled through trusted third-party services. Their privacy policies apply separately. We work with:</p>
            <ul className="policy-list">
              <li>Payment processors (Razorpay, Stripe)</li>
              <li>Shipping and delivery partners</li>
              <li>Email service providers</li>
              <li>Analytics services (for improving user experience)</li>
            </ul>
          </div>

          <div className="policy-section">
            <h3>Cookies</h3>
            <p>Our website uses cookies to enhance your browsing experience. Cookies help us remember your preferences, login details, and shopping cart items. You can disable cookies in your browser settings, but this may affect website functionality.</p>
          </div>

          <div className="policy-section">
            <h3>Your Rights</h3>
            <p>You may request:</p>
            <ul className="policy-list">
              <li>Access to your personal data</li>
              <li>Correction of inaccurate information</li>
              <li>Deletion of your personal data (subject to legal requirements)</li>
              <li>Export of your data in a machine-readable format</li>
              <li>Withdrawal of consent for marketing communications</li>
            </ul>
            <p>To exercise these rights, please contact us at <strong>support@neoteeforge.com</strong>.</p>
          </div>

          <div className="policy-section">
            <h3>Children's Privacy</h3>
            <p>Our services are not directed to children under 13. We do not knowingly collect personal information from children under 13. If you are a parent or guardian and believe your child has provided us with personal information, please contact us immediately.</p>
          </div>

          <div className="policy-section">
            <h3>Changes to This Policy</h3>
            <p>We may update this Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page and updating the "Effective Date" at the top.</p>
          </div>

          <div className="policy-section">
            <h3>Contact Us</h3>
            <p>If you have any questions about this Privacy Policy, please contact us:</p>
            <div style={{ background: '#f8fafc', padding: '1rem', borderRadius: '8px', marginTop: '1rem' }}>
              <p><strong>📧 Email:</strong> support@neoteeforge.com</p>
              <p><strong>🌐 Website:</strong> https://shop.neoteeforge.com</p>
            </div>
          </div>

          <div style={{ marginTop: '3rem', paddingTop: '2rem', borderTop: '1px solid #e2e8f0' }}>
            <p style={{ fontSize: '0.9rem', color: '#64748b' }}>
              <strong>Note:</strong> This policy applies to all NeoTeeForge services including our bookstore, digital products, and any future offerings.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;